import BaseError from './BaseError';
import { getSentryErrorObject } from '../utils/errors';

class ServiceError extends BaseError {
  constructor(error) {
    super();
    this.status = error.response ? error.response.status : false;
    const errorObj = getSentryErrorObject(error);
    this.name = errorObj.reason;
    this.message = errorObj.message;
    this.errors = errorObj;
  }
}

export default ServiceError;
